module.exports = __webpack_public_path__ + "img/pix.231b831d.png";